import * as React from 'react';
import styled from 'styled-components';
import { Styledes, Childable, Acceptable, Closeable } from './types';
import { Layout } from './slots';

export interface Props extends Styledes, Childable, Acceptable, Closeable {}

const Actions = styled.div`
    margin-top: auto;
    padding: 20px 30px;
    text-align: right;
`;


export default React.memo(({ children, accept, handleClose, className }: Props) => {
    return (
        <Actions className={className}>
            {children}
            <Layout name="accept" accept={accept} />
            <Layout name="cancel" handleClose={handleClose} />
        </Actions>
    );
});
